var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooter1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "white",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 0A1.5 1.5 0 0 0 3 1.5V2H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2h-1V1.5A1.5 1.5 0 0 0 11.5 0h-7zM3 3V1.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5V3H3zm10 1v2h-1V4h1zm-1 7V8h-1v4h1zm-2 0V8H9v4h1zm-2 0V8H7v4h1zm-2 0V8H5v4h1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooter1);
export default __webpack_public_path__ + "static/media/footer1.aa5dd22e5860876f7565fe643b134e3d.svg";
export { ForwardRef as ReactComponent };